export default __webpack_public_path__ + "static/media/L2.1bc35e3f.webp";